import React from 'react';
import { motion } from 'framer-motion';
import { Heart, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full bg-[#faf6ef] py-20 px-6 border-t border-[#1e2a4a]/5" data-id="element-1">
      <div className="max-w-[800px] mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-4">
            <div className="flex items-center mb-6" data-id="element-5">
              <Heart className="w-6 h-6 text-[#c9a96e] mr-3 fill-[#c9a96e]" data-id="element-6" />
              <h3 className="text-2xl font-serif font-bold text-[#1e2a4a]" data-id="element-7">
                Perfect if:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-8">
              {['your child is 4–6 and physically capable of staying in bed', 'bedtime is a loop of requests + repeated get-ups', 'you want a warm tone and a firm line', 'you want something you can start tonight'].map((item, index) => <li key={index} className="flex items-start text-lg text-[#1e2a4a]/80" data-id="element-9">
                  <span className="mr-3 text-[#c9a96e]" data-id="element-10">•</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="bg-[#1e2a4a]/5 p-8 rounded-xl" data-id="element-11">
            <div className="flex items-center mb-6" data-id="element-12">
              <XCircle className="w-6 h-6 text-[#6b7fa3] mr-3" data-id="element-13" />
              <h3 className="text-2xl font-serif font-bold text-[#1e2a4a]" data-id="element-14">
                Not for:
              </h3>
            </div>
            <ul className="space-y-4 mb-8" data-id="element-15">
              {['severe night terrors, trauma-related sleep distress, or serious medical sleep concerns', 'situations where nighttime safety is unstable'].map((item, index) => <li key={index} className="flex items-start text-lg text-[#1e2a4a]/80" data-id="element-16">
                  <span className="mr-3 text-[#6b7fa3]" data-id="element-17">•</span>
                  {item}
                </li>)}
            </ul>
            <p className="text-[#6b7fa3] text-sm italic" data-id="element-18">
              (If that's your situation, you're not failing—those deserve
              professional support.)
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}